"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = [{
  id: 'none',
  paths: [],
  viewBox: '0 0 1024 1024'
}, {
  id: 'circle',
  paths: ['M0 512c0-282.77 229.23-512 512-512s512 229.23 512 512c0 282.77-229.23 512-512 512s-512-229.23-512-512z'],
  viewBox: '0 0 1024 1024'
}, {
  id: 'square',
  paths: ['M0 0h1024v1024h-1024z'],
  viewBox: '0 0 1024 1024'
}, {
  id: 'plus',
  paths: ['M992 384h-352v-352c0-17.672-14.328-32-32-32h-192c-17.672 0-32 14.328-32 32v352h-352c-17.672 0-32 14.328-32 32v192c0 17.672 14.328 32 32 32h352v352c0 17.672 14.328 32 32 32h192c17.672 0 32-14.328 32-32v-352h352c17.672 0 32-14.328 32-32v-192c0-17.672-14.328-32-32-32z'],
  viewBox: '0 0 1024 1024'
}, {
  id: 'star',
  paths: ['M1022.442 406.048c-4.274-13.2-16.566-22.142-30.442-22.142l-343.458-0.012-106.122-325.128c-4.296-13.164-16.572-22.072-30.42-22.072s-26.124 8.908-30.42 22.072l-106.12 325.128-343.46 0.012c-13.876 0-26.168 8.942-30.444 22.142-4.274 13.2 0.446 27.65 11.688 35.784l277.736 200.922-106.056 325.026c-4.298 13.174 0.37 27.618 11.568 35.784 11.198 8.162 26.378 8.194 37.606 0.070l277.902-201.006 277.9 201.004c5.598 4.048 12.176 6.072 18.754 6.072 6.62 0 13.236-2.048 18.854-6.142 11.198-8.166 15.868-22.61 11.568-35.784l-106.056-325.024 277.734-200.922c11.242-8.132 15.962-22.582 11.688-35.784z'],
  viewBox: '0 0 1024 1024'
}, {
  id: 'spade',
  paths: ['M817.57 348.15c-193.566-143.858-260.266-259.018-305.566-348.148v0c-0.004 0-0.004-0.002-0.004-0.002v0.002c-45.296 89.13-112 204.292-305.566 348.148-330.036 245.286-19.376 587.668 253.758 399.224-17.796 116.93-78.53 202.172-140.208 238.882v37.744h384.032v-37.74c-61.682-36.708-122.41-121.954-140.212-238.884 273.136 188.446 583.8-153.94 253.766-399.226z'],
  viewBox: '0 0 1024 1024'
}, {
  id: 'club',
  paths: ['M786.832 392.772c-59.032 0-112.086 24.596-149.852 64.694-15.996 16.984-43.762 37.112-73.8 54.81 14.11-53.868 58.676-121.7 89.628-151.456 39.64-38.17 63.984-91.83 63.984-151.5 0.006-114.894-91.476-208.096-204.788-209.32-113.32 1.222-204.796 94.426-204.796 209.318 0 59.672 24.344 113.33 63.986 151.5 30.954 29.756 75.52 97.588 89.628 151.456-30.042-17.7-57.806-37.826-73.8-54.81-37.768-40.098-90.82-64.694-149.85-64.694-114.386 0-207.080 93.664-207.080 209.328 0 115.638 92.692 209.338 207.080 209.338 59.042 0 112.082-25.356 149.85-65.452 16.804-17.872 46.444-40.138 78.292-58.632-3.002 147.692-73.532 256.168-145.318 298.906v37.742h384.014v-37.74c-71.792-42.736-142.32-151.216-145.32-298.906 31.852 18.494 61.488 40.768 78.292 58.632 37.766 40.094 90.808 65.452 149.852 65.452 114.386 0 207.078-93.7 207.078-209.338-0.002-115.664-92.692-209.328-207.080-209.328z'],
  viewBox: '0 0 1024 1024'
}, {
  id: 'diamond',
  paths: ['M512 0l-320 512 320 512 320-512z'],
  viewBox: '0 0 1024 1024'
}, {
  id: 'heart',
  paths: ['M755.188 64c-107.63 0-200.258 87.554-243.164 179-42.938-91.444-135.578-179-243.216-179-148.382 0-268.808 120.44-268.808 268.832 0 301.846 304.5 380.994 512.022 679.418 196.154-296.576 511.978-387.206 511.978-679.418 0-148.392-120.43-268.832-268.812-268.832z'],
  viewBox: '0 0 1024 1024'
}, {
  id: 'moon',
  paths: ['M715.812 64.48c-60.25-34.784-124.618-55.904-189.572-64.48 122.936 160.082 144.768 384.762 37.574 570.42-107.2 185.67-312.688 279.112-512.788 252.68 39.898 51.958 90.376 97.146 150.628 131.934 245.908 141.974 560.37 57.72 702.344-188.198 141.988-245.924 57.732-560.372-188.186-702.356z'],
  viewBox: '0 0 1024 1024'
}];